import { Navigate } from 'react-router-dom';
import { useAuth, canEditShizai, canRequestParts, canUseApp } from '@/auth/AuthContext';
import ShizaiDashboard from './ShizaiDashboard';

/**
 * Smart entry point for `/shizai`. Routes each user to the view that matches
 * their role — no need to hunt for the right page manually:
 *
 *   Requester (has shizai_request AND app_parts_request access) → /parts-request
 *   Buyer / Admin (has shizai_edit)                              → workflow dashboard
 *
 * Historical note: buyers/admins used to land on the Kanban board here. That
 * caused two "dashboards" to exist (the KPI page at /shizai/dashboard and the
 * board at /shizai). Now /shizai is the one true dashboard, and the Kanban
 * board is a first-class sibling at /shizai/kanban.
 */
export default function ShizaiHome() {
  const { user } = useAuth();
  const canOpenPartsRequest = canUseApp(user, 'parts_request');
  if (!canEditShizai(user) && canRequestParts(user) && canOpenPartsRequest) {
    return <Navigate to="/parts-request" replace />;
  }
  return <ShizaiDashboard />;
}
